import React from 'react';
import { RatingStars } from 'src/components';

export const getRatingStarsOutput = (value: string) => { 
  const aux = parseFloat(value);
  return <RatingStars preSelectedRate={aux} isPrevStep />;
};
